
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/goodbarber",
      function () {
        return require("private-next-pages/[locale]/goodbarber/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/goodbarber"])
      });
    }
  